import { InputAdornment } from "@material-ui/core";
import React from "react";
import clsx from "clsx";

import useStyles from '../../TextField.style';

export const TextFieldAdornment = ({
  position,
  children,
  disabled = false,
}: {
  position: "start" | "end";
  children?: React.ReactNode;
  disabled?: boolean;
}) => {
  const c = useStyles({});
  return   children ? (
    <InputAdornment position={position} disableTypography={true} className={clsx(disabled && c.inputAdornmentDisabled)}>{children}</InputAdornment>
  ) : null;
}
